import { useEffect, useRef, useState } from "react";
import { categoryIcons } from "./skillsData";

export const SkillCategory = ({
  category,
  skills,
  index,
}: {
  category: string;
  skills: string[];
  index: number;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);
  const Icon = categoryIcons[category as keyof typeof categoryIcons];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.1 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className={`transition-all duration-350 ease-out h-full ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="bg-card border-2 rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-200 ease-out h-full flex flex-col min-h-[280px]">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0">
            <Icon className="h-5 w-5 text-white" />
          </div>
          <h3 className="text-lg font-bold">{category}</h3>
        </div>

        <div className="flex flex-wrap gap-2 flex-1 content-start">
          {skills.map((skill, idx) => (
            <span
              key={idx}
              className="px-3 py-1.5 bg-secondary/50 text-secondary-foreground rounded-full text-sm font-medium
                         hover:bg-gradient-to-r hover:from-primary hover:to-accent hover:text-white
                         transition-colors duration-200 ease-out cursor-default h-fit"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
